import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import { ArrowRightIcon } from "@phosphor-icons/react";

import { StudentSummary } from "../../../../graphql/generated/graphql";
import TableControlsContainer from "../../../../containers/general/TableControls/TableControlsContainer";
import CustomText from "../../../common/general/CustomText/CustomText";

interface StudentsListProps {
  studentsData: {
    data: StudentSummary[];
    count: number;
  } | null;
  onStudentSelect: (studentId: string) => void;
  page: number;
  setPage: (page: number) => void;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
}

const StudentsList: React.FC<StudentsListProps> = ({
  studentsData,
  onStudentSelect,
  page,
  setPage,
  pageSize,
  setPageSize,
}) => {
  return (
    <View>
      {studentsData?.data?.map((student) => (
        <TouchableOpacity key={student.id} style={styles.studentCard} onPress={() => onStudentSelect(student.id)}>
          <CustomText text={student.label || "Unnamed Student"} weight="bold" useTranslationText={false} />
          <CustomText text={`Success Points: ${student.success_points || 0}`} size="s" useTranslationText={false} />
          <CustomText text={`Confusion Points: ${student.confusion_points || 0}`} size="s" useTranslationText={false} />
          <CustomText text={`Questions Asked: ${student.questions_asked || 0}`} size="s" useTranslationText={false} />
          <View style={styles.actionContainer}>
            <CustomText text="Tap to view details" size="xs" style={styles.actionText} />
            <ArrowRightIcon size={12} color="#0084FF" />
          </View>
        </TouchableOpacity>
      ))}
      {studentsData?.count > 0 && (
        <TableControlsContainer
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          totalCount={studentsData?.count}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  studentCard: {
    padding: 16,
    backgroundColor: "#f8f9fa",
    borderRadius: 8,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: "#e5e5e5",
    cursor: "pointer",
  },
  actionContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  actionText: {
    color: "#0084FF",
    fontStyle: "italic",
  },
});

export default StudentsList;
